import React from "react";
import { Link } from "react-router-dom";
import website_logo from '../../assets/logoWebsite.png';
export default function News(props) {
  return (
    <div className="news-container">
      <img src={website_logo} className="news-container__website-logo" alt="website-logo"/>
      <div className="news-container__image-container">
        {props.images.map((value,index) => {
          return (
            <img key={index} src={value} alt="image1" className="news-container__image" />
          );
        })}
        {props.titleExeption ? 
      <div className='card-board__infos'>
                <h4 className='card-board__headerTitle'>abubaker seddiq alkhoori</h4>
                <h5 className='card-board__headerSubTitle'>GEN, Chairman of the Board</h5>
                <h5 className='card-board__InfoTitle'>Abubaker Seddiq AlKhoori Appointed Chairman of the Board at GEN, Effective February 19,2024</h5>
      </div>
      : ''  
      }
      </div>
      {props.source ? <h5>source: {props.source}</h5> : ""}
      <p className="news-container__paragraphe">
        {props.paragraphe}
        {props.link !== "" ? (
          <a href={props.link} target="_blank" rel="noreferrer">
            Read more...
          </a>
        ) : (
          ""
        )}
        {props.inPageLink === true ? (
          <Link to={`/news/${props.id}`} >
            Read more...
          </Link>
        ) : (
          ""
        )}
      </p>
    </div>
  );
}
